import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin, Observable, Subscription } from 'rxjs';
// models
import { AdsModel } from '../../models/ads.model';
// services
import { BroadcastService } from '../../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../../shared/services/form.service';
import { AdsService } from '../../../../../../services/ads.service';
import { RoutesService } from '../../../../../../services/routes.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    // tslint:disable-next-line: component-selector
    selector: 'ads-edit-create',
    templateUrl: './edit-create.component.html',
    styleUrls: ['./edit-create.component.scss']
})
export class AdsEditCreateComponent implements OnInit, OnDestroy {
    @Input() data: any = {};
    formGroup: RxFormGroup;
    subscriptions: Array<Subscription | Observable<any>> = [];

    routesList = [];
    fields = {
        name: {
            type: 'input',
            options: {
                path: 'name',
                label: {
                    text: 'Nombre'
                }
            }
        },
        type: {
            type: 'select',
            options: {
                path: 'type',
                label: {
                    text: 'Tipo de Publicidad'
                },
                dropdown: {
                    text: 'Seleccione...',
                    options: [
                        {
                            id: 'image',
                            name: 'Imagen'
                        },
                        {
                            id: 'video',
                            name: 'Video'
                        }
                    ]
                }
            }
        },
        route: {
            type: 'select',
            options: {
                path: 'routesId',
                label: {
                    text: 'Ruta'
                },
                dropdown: {
                    text: 'Seleccione...',
                    default: null,
                    options: [
                    ]
                }
            }
        },
        activeFrom: {
            type: 'datepicker',
            options: {
                path: 'activeFrom',
                class: 'col-sm-12',
                label: {
                    text: 'Desde',
                    class: 'col-sm-12'
                }
            }
        },
        activeTo: {
            type: 'datepicker',
            options: {
                path: 'activeTo',
                class: 'col-sm-12',
                label: {
                    text: 'Hasta',
                    class: 'col-sm-12'
                }
            }
        },
        url: {
            type: 'input',
            options: {
                path: 'url',
                label: {
                    text: 'Publicidad'
                }
            }
        },
        image: {
            type: 'image',
            options: {
                path: 'image',
                label: {
                    text: 'Publicidad'
                },
                image: {
                    src: null
                }
            }
        },
        active: {
            type: 'switch',
            options: {
                path: 'active',
                label: {
                    text: '¿Activo?'
                },
                switchers: {
                    trueCaption: 'Si',
                    falseCaption: 'No'
                }
            }
        },
    };
  
    constructor(
        private cdr: ChangeDetectorRef,
        public modalRef: BsModalRef,
        private broadcast: BroadcastService,
        private formService: FormService,
        private adsService: AdsService,
        private routesService: RoutesService
    ) {
        this.subscriptions.push(
            this.formService._formEvents.subscribe(data => {
                this.formGroup = data;
            })
        );
    }

    ngOnInit(): void {
        this.formService.transformIntoFormGroup(AdsModel, this.data);

        if ('id' in this.data) {
            this.subscriptions.push(
                forkJoin([
                    this.routesService.list(),
                    this.adsService.show(this.data.id),
                ]).subscribe(data => {
                    // this.routesList = data[0]['response'];
                    this.fields.route.options.dropdown.options = [...data[0]['response']];
                    this.fields.image.options.image.src = data[1]['response']['image_url'];
                    this.formGroup.patchModelValue(data);
                })
            );
        } else {
            this.subscriptions.push(
                this.routesService.list().subscribe((data: any) => {
                    // this.routesList = data.response;
                    this.fields.route.options.dropdown.options = [...data.response];
                })
            );
        }

        this.formGroup.valueChanges.subscribe(data => {
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });    
    }

    /**
     * 
     */
    submit(): void {
        this.subscriptions.push(
            this.adsService.createOrUpdate(this.formGroup, this.data?.id).subscribe(
                data => {
                    this.broadcast.reloadDataTable();
                    this.modalRef.hide();
                }
            )
        );
    }

}
